<template>
  <div class="print-page">
    <div style="height: calc(100vh - 80px); overflow-y: auto">
      <div id="print">
        <div class="A4-page">
          <div class="survey-info">
            <h1>
              {{ dataObj.questionnaireName }}
            </h1>
            <h4>
              {{ dataObj.questionnaireDescribe }}
            </h4>
          </div>
          <div v-if="questionnaireType === '1'">
            <div
              v-for="(item, index) in addQuestionsList"
              :key="index"
              @click.stop=""
            >
              <div class="item" v-if="item.type == QuestionType.SCQ">
                <div style="position: relative">
                  <QuestionPreviewSCQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewSCQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.MCQ">
                <div style="position: relative">
                  <QuestionPreviewMCQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewMCQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.SBQ">
                <div style="position: relative">
                  <QuestionPreviewSBQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewSBQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.MBQ">
                <div style="position: relative">
                  <QuestionPreviewMBQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewMBQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.DLQ">
                <div style="position: relative">
                  <QuestionPreviewDLQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewDLQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.NPS">
                <div style="position: relative">
                  <QuestionPreviewNPS
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewNPS>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.QA">
                <div style="position: relative">
                  <QuestionPreviewQA
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewQA>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.SRQ">
                <div style="position: relative">
                  <QuestionPreviewSRQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewSRQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.VOTE">
                <div style="position: relative">
                  <QuestionPreviewVote
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewVote>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.SORT">
                <div style="position: relative">
                  <QuestionPreviewSort
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewSort>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.SCORE">
                <div style="position: relative">
                  <QuestionPreviewScore
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewScore>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.WRQ">
                <div style="position: relative">
                  <QuestionPreviewWRQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewWRQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.REMARK">
                <div style="position: relative">
                  <QuestionPreviewRemark
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewRemark>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.NAME">
                <div style="position: relative">
                  <QuestionPreviewName
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewName>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.GENDER">
                <div style="position: relative">
                  <QuestionPreviewGender
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewGender>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.AGE">
                <div style="position: relative">
                  <QuestionPreviewAge
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewAge>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.TEL">
                <div style="position: relative">
                  <QuestionPreviewTel
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewTel>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.EMAIL">
                <div style="position: relative">
                  <QuestionPreviewEmail
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewEmail>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.DATE">
                <div style="position: relative">
                  <QuestionPreviewDate
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewDate>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.TIME">
                <div style="position: relative">
                  <QuestionPreviewTime
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewTime>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ADDR">
                <div style="position: relative">
                  <QuestionPreviewAddress
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewAddress>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.IMAGE">
                <div style="position: relative">
                  <QuestionPreviewImage
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewImage>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.MaxDiff">
                <div style="position: relative">
                  <QuestionPreviewMaxDiff
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewMaxDiff>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.UploadFile">
                <div style="position: relative">
                  <QuestionPreviewUploadFile
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewUploadFile>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.DownloadFile">
                <div style="position: relative">
                  <QuestionPreviewDownloadFile
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewDownloadFile>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.CASCADER">
                <div style="position: relative">
                  <QuestionPreviewCASCADER
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewCASCADER>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.BDQ">
                <div style="position: relative">
                  <QuestionPreviewBDQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewBDQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.IDQ">
                <div style="position: relative">
                  <QuestionPreviewIDQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewIDQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ELQ">
                <div style="position: relative">
                  <QuestionPreviewELQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewELQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.WX">
                <div style="position: relative">
                  <QuestionPreviewWX
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewWX>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.TITLE">
                <div style="position: relative">
                  <QuestionPreviewTitle
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewTitle>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ImageSCQ">
                <div style="position: relative">
                  <QuestionPreviewImageScq
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewImageScq>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ImageMCQ">
                <div style="position: relative">
                  <QuestionPreviewImageMcq
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewImageMcq>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.MatrixSCQ">
                <div style="position: relative">
                  <QuestionPreviewMatrixScq
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewMatrixScq>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.MatrixMCQ">
                <div style="position: relative">
                  <QuestionPreviewMatrixMcq
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewMatrixMcq>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ImageOrVideo">
                <div style="position: relative">
                  <QuestionPreviewImageOrVideo
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewImageOrVideo>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.Signature">
                <div style="position: relative">
                  <QuestionPreviewSignature
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewSignature>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.PageBreak">
                <div style="position: relative">
                  <QuestionPreviewPageBreak
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewPageBreak>
                  <div class="mask-div"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="questionnaireType === '2'">
            <div
              v-for="(item, index) in addQuestionsList"
              :key="index"
              @click.stop=""
            >
              <div class="item" v-if="item.type == QuestionType.SCQ">
                <div style="position: relative">
                  <ExamPreviewSCQ
                    :params="{ data: item, index: index }"
                  ></ExamPreviewSCQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.MCQ">
                <div style="position: relative">
                  <ExamPreviewMCQ
                    :params="{ data: item, index: index }"
                  ></ExamPreviewMCQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.SBQ">
                <div style="position: relative">
                  <ExamPreviewSBQ
                    :params="{ data: item, index: index }"
                  ></ExamPreviewSBQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.MBQ">
                <div style="position: relative">
                  <ExamPreviewMBQ
                    :params="{ data: item, index: index }"
                  ></ExamPreviewMBQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.TFQ">
                <div style="position: relative">
                  <ExamPreviewTFQ
                    :params="{ data: item, index: index }"
                  ></ExamPreviewTFQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.QA">
                <div style="position: relative">
                  <ExamPreviewQA
                    :params="{ data: item, index: index }"
                  ></ExamPreviewQA>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.IMAGE">
                <div style="position: relative">
                  <ExamPreviewIMAGE
                    :params="{ data: item, index: index }"
                  ></ExamPreviewIMAGE>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ClozeTest">
                <div style="position: relative">
                  <ExamPreviewClozeTest
                    :params="{ data: item, index: index }"
                  ></ExamPreviewClozeTest>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.NAME">
                <div style="position: relative">
                  <QuestionPreviewName
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewName>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.GENDER">
                <div style="position: relative">
                  <QuestionPreviewGender
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewGender>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.AGE">
                <div style="position: relative">
                  <QuestionPreviewAge
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewAge>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.TEL">
                <div style="position: relative">
                  <QuestionPreviewTel
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewTel>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.EMAIL">
                <div style="position: relative">
                  <QuestionPreviewEmail
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewEmail>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.DATE">
                <div style="position: relative">
                  <QuestionPreviewDate
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewDate>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.TIME">
                <div style="position: relative">
                  <QuestionPreviewTime
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewTime>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ADDR">
                <div style="position: relative">
                  <QuestionPreviewAddress
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewAddress>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.BDQ">
                <div style="position: relative">
                  <QuestionPreviewBDQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewBDQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.IDQ">
                <div style="position: relative">
                  <QuestionPreviewIDQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewIDQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ELQ">
                <div style="position: relative">
                  <QuestionPreviewELQ
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewELQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.WX">
                <div style="position: relative">
                  <QuestionPreviewWX
                    :params="{ data: item, index: index }"
                  ></QuestionPreviewWX>
                  <div class="mask-div"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="questionnaireType === '3'">
            <div
              v-for="(item, index) in addQuestionsList"
              :key="index"
              @click.stop=""
            >
              <div class="item" v-if="item.type == QuestionType.EvaluationSCQ">
                <div style="position: relative">
                  <EvaluationPreviewSCQ
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewSCQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.EvaluationMCQ">
                <div style="position: relative">
                  <EvaluationPreviewMCQ
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewMCQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.EvaluationWRQ">
                <div style="position: relative">
                  <EvaluationPreviewWRQ
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewWRQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.EvaluationNPS">
                <div style="position: relative">
                  <EvaluationPreviewNPS
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewNPS>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div
                class="item"
                v-if="item.type == QuestionType.EvaluationScore"
              >
                <div style="position: relative">
                  <EvaluationPreviewScore
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewScore>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div
                class="item"
                v-if="item.type == QuestionType.TextDescription"
              >
                <div style="position: relative">
                  <EvaluationPreviewDesc
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewDesc>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.NAME">
                <div style="position: relative">
                  <EvaluationPreviewName
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewName>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.GENDER">
                <div style="position: relative">
                  <EvaluationPreviewGender
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewGender>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.AGE">
                <div style="position: relative">
                  <EvaluationPreviewAge
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewAge>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ELQ">
                <div style="position: relative">
                  <EvaluationPreviewELQ
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewELQ>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.DATE">
                <div style="position: relative">
                  <EvaluationPreviewDate
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewDate>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.ADDR">
                <div style="position: relative">
                  <EvaluationPreviewAddress
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewAddress>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.Industry">
                <div style="position: relative">
                  <EvaluationPreviewIndustry
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewIndustry>
                  <div class="mask-div"></div>
                </div>
              </div>
              <div class="item" v-if="item.type == QuestionType.Occupation">
                <div style="position: relative">
                  <EvaluationPreviewOccupation
                    :params="{ data: item, index: index }"
                  ></EvaluationPreviewOccupation>
                  <div class="mask-div"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-button v-print="`#print`">打印</el-button>
    </div>
  </div>
</template>
<script>
import { questionTempList, questionnaireUpdateDetail } from "@/api/index.js";
import { PreviewComponents } from "@/utils/componentImports.js";

export default {
  components: {
    ...PreviewComponents,
  },
  data() {
    return {
      uuid: "",
      QuestionType: this.$store.getters["questionType/getQuestionType"],
      addQuestionsList: [],
      dataObj: {},
      questionnaireType: "",
    };
  },
  mounted() {
    this.uuid = this.$route.query.id;
    this.questionnaireType = this.$route.query.type;
    this.queryDetail();
  },
  created() {},
  // 组件定义同方案一
  methods: {
    async queryDetail() {
      await questionnaireUpdateDetail({
        uuid: this.uuid,
      })
        .then((res) => {
          if (res.code === 200) {
            console.log("res111111111111111", res);
            this.dataObj = res.data;
            this.queryQuestionTempList();
          }
        })
        .catch((err) => {
          console.log("err", err);
        });
    },
    async queryQuestionTempList() {
      await questionTempList({
        uuid: this.uuid, // 活动唯一标识
        predivStatus: 0,
      })
        .then((res) => {
          if (res.code === 200) {
            this.addQuestionsList = res.data;
            this.addQuestionsList.forEach((element) => {
              element.status = "1";
            });
          }
          //   this.loading.close();
        })
        .catch((err) => {
          this.loading.close();
          console.log("err", err);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.print-page {
  width: 100%;
  display: flex;
  justify-content: center;
}

.A4-page {
  width: 1152px;
  //   transform: scale(0.98, 0.98);
  background-color: white;
  padding: 10px 15px;
  box-sizing: border-box;
}

.survey-info {
  width: 100%;
  padding: 10px;
  box-sizing: border-box;
  background: #ffffff;

  h1 {
    width: 100%;
    font-size: 18px;
    font-family: PingFang SC, PingFang SC-Medium;
    font-weight: Medium;
    text-align: left;
    color: #323b5a;
    text-align: center;
  }

  h4 {
    font-size: 13px;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: Regular;
    text-align: left;
    color: #7e7e81;
    line-height: 18px;
  }
}

.item {
  width: 100%;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/PrintPreview/index.vue